<template>
  <b-modal ref="passwordPrompt" id="passwordPrompt" centered lazy
           :title="modalTitle"
           cancel-title="Anuluj"
           :header-class="hasToSetPassword ? 'border-0' : ''"
           :footer-class="hasToSetPassword ? 'border-0' : ''"
           :body-class="hasToSetPassword ? 'd-none' : ''"
           ok-title="Usuń konto" ok-variant="danger" @hidden="clearPasswordPrompt" @ok="deleteAccount">

    <b-alert variant="info" :show="agreement">
      Wycofanie zgody obowiązkowej jest jednoznaczne z rezygnacją z uczestnictwa w niniejszym programie lojalnościowym.
      W takim przypadku Twoje konto i wszystkie zgromadzone dane zostaną nieodwracalnie usunięte.
    </b-alert>

    <b-alert dismissible
             fade
             :show="isPasswordError"
             @dismissed="passwordError = ''"
             variant="warning">
      {{ passwordError }}
      <template slot="dismiss" class="pull-right">
        &nbsp;
      </template>
    </b-alert>

    <input type="password" class="form-control" v-model="password" placeholder="Hasło">
  </b-modal>
</template>

<script>
import {mapActions, mapState} from 'vuex'

  export default {
    name: "DeleteAccountPasswordPromptModal",
    props: {
      agreement: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        password: '',
        passwordError: '',
      }
    },
    methods: {
      ...mapActions([
        'logout',
        'setLoginInfo'
      ]),
      show() {
        this.$refs.passwordPrompt.show();
      },
      deleteAccount(e) {
        e.preventDefault();

        if (!this.password.length && !this.hasToSetPassword) {
          this.passwordError = 'Musisz podać hasło.';
          return;
        }

        this.$http.post('account/delete', {
          password: this.password
        })
          .then((r) => {
            if (r.data.success) {
              this.$refs.passwordPrompt.hide();
              this.setLoginInfo(r.data.message);
              this.logout();
            } else {
              this.passwordError = r.data.message;
            }
          });
      },
      clearPasswordPrompt() {
        this.passwordError = '';
        this.password = '';
      }
    },
    computed: {
      ...mapState({
        hasToSetPassword: state => state.auth.user.set_password,
      }),
      isPasswordError() {
        return !!this.passwordError.length
      },
      modalTitle() {
        if (this.hasToSetPassword) {
          return 'Potwierdź usunięcie konta.';
        }

        return this.agreement
          ? 'Podaj swoje hasło, aby wycofać zgodę i usunąć konto.'
          : 'Podaj swoje hasło, aby usunąć konto.'
      }
    }
  }
</script>

<style scoped>

</style>
